module.exports = {"TXTWCL_We_keep_your_data_safe":{"id":"TXTWCL_We_keep_your_data_safe","defaultMessage":"Păstrăm datele tale în siguranţă"}}